"use client";

import type { MouseEvent, ReactNode } from "react";
import { createClient } from "@/lib/supabase/client";

interface GoogleLoginButtonProps {
  children: ReactNode;
  next?: string;
  className?: string;
}

export function GoogleLoginButton({
  children,
  next = "/library",
  className,
}: GoogleLoginButtonProps) {
  const handleClick = async (
    event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  ) => {
    event.preventDefault();
    if (typeof window === "undefined") return;

    try {
      const supabase = createClient();
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (user) {
        window.location.href = next;
        return;
      }

      const redirectTo = `${window.location.origin}/auth/callback?next=${encodeURIComponent(
        next,
      )}`;

      await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          redirectTo,
        },
      });
    } catch {
      window.location.href = `/auth/login?next=${encodeURIComponent(next)}`;
    }
  };

  return (
    <button type="button" onClick={handleClick} className={className}>
      {children}
    </button>
  );
}
